export function isSafari(userAgent: string): boolean {
  const isApple = /iPhone|iPad|iPod|Macintosh/.test(userAgent);
  const isSafariBrowser = /Safari/.test(userAgent);
  const isAnotherBrowser = /CriOS|FxiOS|OPiOS|EdgiOS|Chrome/.test(userAgent);
  return isApple && isSafariBrowser && !isAnotherBrowser;
}
